import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Tab, Nav, Button } from 'react-bootstrap';
import { useWindowSize } from 'hooks';
import { useHistory, Link } from 'react-router-dom';
import styles from './styles.module.scss';

export default function Tabs({
  listOfSections = [],
  onChangeSection,
  variant = '',
  className = '',
  navContainerClassName = '',
  customActiveSection = '',
  defaultSection = null,
  showDocumentation='',
  eventIsInFuture='',
  tableInfo='',
  ...props
}) {
  const [currentSection, setCurrentSection] = useState(
    defaultSection || listOfSections[0].id
  );

  const handleSelect = (sectionId) => {
    setCurrentSection(sectionId);
  };

  useEffect(() => {
    if (onChangeSection) onChangeSection(currentSection);
  }, [onChangeSection, currentSection]);

  useEffect(() => {
    if (customActiveSection) {
      setCurrentSection(customActiveSection);
    }
  }, [customActiveSection]);

  const isSecondary = variant === 'secondary';

  const [TC, setTC] = useState(false)
  // const contrato_virtual = 'https://sears-mesa.s3.amazonaws.com/legales/CONTRATO-PLAN-VIRTUAL.pdf'
  // const contrato_fisica = 'https://sears-mesa.s3.amazonaws.com/legales/CONTATO-PLAN-LO-QUIERO.pdf'
  const contrato_virtual = 'https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/CONTRATO-PLAN-VIRTUAL.pdf'
  const contrato_fisica = 'https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/CONTATO-PLAN-LO-QUIERO.pdf'
  useEffect(() => {
    // console.log('Tabs: ', tableInfo)
    if(tableInfo?.plan?.name){
      setTC(tableInfo?.plan?.name)
    }
  },[tableInfo?.plan?.name])



  if (listOfSections.length === 0) return null;

  const { isMobile } = useWindowSize({ largeMobile: true })[1];
  const history = useHistory();
  const handleAddProduct = ()=> history.push('/agregar-regalos')

  return (
    <Tab.Container
      defaultActiveKey={currentSection}
      onSelect={handleSelect}
      {...props}
      id="my_table_tabs"
    >
      <div
        className={classNames(
          styles.tabs,
          navContainerClassName || 'd-flex',
          isSecondary && 'justify-content-center'
        )}
      >
        {listOfSections.map(({ id, title, verify }) => {
          const activeSection = id === currentSection;
          if ((verify && showDocumentation && !eventIsInFuture) || !verify){
            return (
              <div
                key={id}
                className={classNames(
                  !isSecondary && 'mx-2',
                  isSecondary && styles.secondaryNavContainer
                )}
                style={
                  isSecondary ? { width: `${100 / listOfSections.length}%` } : {}
                }
              >
                <Nav>
                  <Nav.Item>
                    <Nav.Link eventKey={id} className="p-0">
                      {isSecondary ? (
                        <div
                          className={classNames(
                            styles.secondaryNav,
                            activeSection && styles.secondaryNav_active
                          )}
                        >
                          {title}
                        </div>
                      ) : (
                        <Button
                          variant={`${
                            id === currentSection ? 'primary primaryButton' : 'secondary secondaryButton'
                          }`}
                          className="btn-flat"
                        >
                          {title}
                        </Button>
                      )}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            );
          }
        })}

        {TC
          ?
            TC === 'VIRTUAL'
              ?
                <div className="mx-2">
                  <div className="nav" role="tablist">
                    <div className="nav-item">
                      <a href={contrato_virtual} target='_blank' download className="p-0 nav-link" rel="noreferrer">
                        <button type="button" className="btn-flat btn btn-secondary secondaryButton">Términos y condiciones</button>
                      </a>
                    </div>
                  </div>
                </div>
              :
                <div className="mx-2">
                  <div className="nav" role="tablist">
                    <div className="nav-item">
                      <a href={contrato_fisica} target='_blank' download className="p-0 nav-link" rel="noreferrer">
                        <button type="button" className="btn-flat btn btn-secondary secondaryButton">Términos y condiciones</button>
                      </a>
                    </div>
                  </div>
                </div>
          : null
        }

      </div>

      <Tab.Content
        className={classNames(isSecondary && 'pt-3 pt-xl-4', className)}
      >
        {listOfSections.map(
          ({
            id,
            Section,
            sectionProps = {},
            className: tabClassName = id === 'my_table' ? 'w-100' : '',
          }) => (
            <Tab.Pane key={id} eventKey={id} className={tabClassName}>
            <Tab.Content >
                {isMobile && id === 'my_table' && (
                  <>       
                        
                  <div className="container"  onClick={handleAddProduct} role="button">
                    <div className="row justify-content-center mt-5">
                      <div className="col-md-4">
                      
                        <div className={`text-center ${styles.dotted_border_box}`}>
                          <i className="fa fa-plus-circle" /><br />
                          Agregar regalo
                        </div>
                      </div>
                    </div>
                  </div>
                  </>

                )}
            </Tab.Content>
              <Section {...sectionProps} />
            </Tab.Pane>
          )
        )}
      </Tab.Content>
    </Tab.Container>
  );
}
